exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-toast-bg[data-v-0825c1fc]{position:fixed;z-index:9002;top:0;left:0;right:0;bottom:0;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.lp-toast[data-v-0825c1fc]{width:60%;max-width:380px;margin:auto;padding:12px;font-size:.9rem;color:#fff;background-color:rgba(0,0,0,.65);text-align:center;border-radius:4px}.fade-enter-active[data-v-0825c1fc],.fade-leave-active[data-v-0825c1fc]{-webkit-transition:opacity .3s;transition:opacity .3s}.fade-enter[data-v-0825c1fc],.fade-leave-to[data-v-0825c1fc]{opacity:0}", ""]);

// exports
